const getContentShow = (): [string] => {
  const toursStarted = localStorage.getItem('HJAppcuesContentShown');
  return toursStarted !== null ? JSON.parse(toursStarted) : [];
};

export const showContent = (contentId: string, showOnce = false): void => {
  const toursStarted = getContentShow();

  if (showOnce && toursStarted.includes(contentId)) {
    return;
  }

  if (window.Appcues) {
    window.Appcues.show(contentId);
    if (showOnce) {
      toursStarted.push(contentId);
      localStorage.setItem('HJAppcuesContentShown', JSON.stringify(toursStarted));
    }
  }
};
